import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { ticketEmailSettingsEffects } from 'src/app/root-store/tickets-store/effects';
import { reducer, ticketingEmailFeatureKey } from 'src/app/root-store/tickets-store/ticket-email-settings.reducer';
import { EnvironmentProviders } from '@angular/core';

export const provideTicketEmailSettingsStore = (): EnvironmentProviders[] => [
    provideState(ticketingEmailFeatureKey, reducer),
    provideEffects(ticketEmailSettingsEffects)
];
